import clsx from 'clsx';
import Card from 'components/atoms/Card/Card';
import Image from 'components/atoms/Image/Image';
import Txt from 'components/atoms/Txt/Txt';
import { useTranslation } from 'next-i18next';
import { graphql, useLazyLoadQuery } from 'react-relay';
import { BarcBannerQuery } from './__generated__/BarcBannerQuery.graphql';
import Chevron from './assets/chevron.svg';
import classes from './BarcBanner.module.scss';

export type Props = {
  className: string;
  onClick: () => void;
};

export default function BarcBanner({ className, onClick }: Props) {
  const { t } = useTranslation();
  const data = useLazyLoadQuery<BarcBannerQuery>(
    graphql`
      query BarcBannerQuery {
        cookies {
          edges {
            node {
              cookieId
              consent {
                status
              }
            }
          }
        }
      }
    `,
    {},
    { fetchPolicy: 'store-and-network' },
  );

  const newOrExpiredCookies = Boolean(
    data.cookies?.edges?.filter(
      (edge) => edge?.node?.consent?.status === 'NEW' || edge?.node?.consent?.status === 'EXPIRED',
    ).length,
  );

  return newOrExpiredCookies ? (
    <Card className={clsx(classes.root, className)} onClick={onClick}>
      <Image
        className={classes.iconImage}
        src="/assets/rocket.gif"
        alt={t('A rocket taking off')}
        width={150}
        height={113}
      />
      <Txt className={classes.text}>Boost Your Survey Eligibility</Txt>
      <Chevron className={classes.chevron} />
    </Card>
  ) : null;
}
